// DiFi rate limit is 2 requests per user per second, 600 seems like a safe option.
export const DEFAULT_DEBOUNCE_TIME = 600;

export const profileFeatures = {
    branding: 'branding',
    performance: 'performance',
    purchases: 'purchases',
    accountMaintenance: 'accountMaintenance',
    accounts: 'accounts',
    accessGroups: 'accessGroups',
    productProfile: 'productProfile',
    productOverview: 'productOverview',
    accountDocuments: 'accountDocuments',
    accountOrders: 'accountOrders',
    accountSupportingDocuments: 'accountSupportingDocuments',
    pylonChat: 'pylonChat',
    // Note `orderAdmin` is both a feature name and a role name (constants.profileTypes.ORDER_ADMIN).
    // The strings collide but come from different fields on the profile, and the order Admin tab
    // requires both halves — see order-admin.utils.ts.
    orderAdmin: 'orderAdmin',
    clientOrderAdmin: 'clientOrderAdmin',
    cancelDraftOrders: 'cancelDraftOrders',
    accountDocumentExport: 'accountDocumentExport',
    sellingAgreements: 'sellingAgreements'
} as const;
